import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import { CellModel, ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import rp, { GridEditorAdapter, GridEditorOptions, RowData } from "@reporting/rp-app-host";
import { AccessRole } from "@reporting/rp-types/users";
import { GroupUsersTreeAdapter } from "../adapters";

const PAGE_SIZE = 500;

export class UserGroupGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	constructor(
		private g: number = null,
	) { super(); }


	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;
		this._columns = [{
			t: 'a',
			e: false,
			w: 5 + 20 * 3,
			content: [{
				action: rp.userProvider.isGroupAdmin() ? 'delete' : '',
				title: msg('Delete'),
				icon: 'trash',
				color: 'red'
			}, {
				action: 'access',
				title: msg('Access'),
				icon: 'key',
				color: 'yellow'
			}, {
				action: rp.userProvider.isGroupAdmin() ? 'settings' : '',
				title: msg('Settings'),
				icon: 'gear',
				color: 'gray'
			}],
			filter: false
		}, {
			data: 'id_access_role',
			header: '#',
			t: 'n',
			e: false,
			w: 80,
			z: '0'
		}, {
			data: 'role',
			header: msg('Group'),
			t: 't',
			w: 150
		}, {
			data: 'users',
			header: msg('Users'),
			t: 'm',
			w: 500,
			adapter: new GroupUsersTreeAdapter(this.g)
		}, {
			data: 'description',
			header: msg('Description'),
			t: 't',
			w: 300
		}, {
			data: 'email',
			header: msg('Email'),
			t: 't',
			w: 200
		}, {
			data: 'who_created',
			header: msg('Created by'),
			t: 't',
			e: false,
			w: 170
		}, {
			data: 'date_created',
			header: msg('Created'),
			t: 'dt',
			e: false,
			w: 145
		}, {
			data: 'idz',
			t: 'n',
			e: false,
			hidden: true
		}];
		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]>{
		const roles = await rp.ms('users').get<AccessRole[]>(
			'accessRoles',
			this.createRequestParams(filters, { count: PAGE_SIZE, ...(this.g ? { g: this.g } : {}) })
		);
		return roles.map(data => ({ data: {
			...data,
			users: { v: data.users, dv: data.display_users },
		}}));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			filters: true,
			pageSize: PAGE_SIZE,
			refreshAfterSave: true,
			editable: rp.userProvider.isGroupAdmin(),
			toolbar: {
				new: {
					text: msg('New group'),
					color: ColorTypes.Blue,
					icon: 'plus',
					enabled: rp.userProvider.isGroupAdmin(),
				},
				save: { enabled: rp.userProvider.isGroupAdmin() },
				discard: { enabled: rp.userProvider.isGroupAdmin() },
			},
		});
	}

	async save(rowData: RowData[]) {
		const data = rowData.map(row => Object.assign({
				_state: row.state,
				_index: row.index,
				id_accounting_group: this.g ?? rp.accountingProvider.accounting.id_accounting_group
			},
			row.data
		));
		data.forEach(row => {
			row.positive = !row.negative;
			this._columns.filter(c => ['s', 'm'].includes(c.t)).forEach(col => {
					const value = row[col.data];
					if (Array.isArray(value) && value.every(Array.isArray)) {
						row[col.data] = value.map(([first]) => first);
					}
				});
		});
		await rp.ms('users').post('accessRoles', data);
	}

	onAction(action: string, cell: CellModel) {
		const data = cell?.row.data;
		switch (action) {
			case 'access':
				if (data) {
					rp.host.open(
						`users-userAccessContainer-g-${this.g}-r-${data.id_access_role}`,
						{ title: `${msg('Access')}: ${data.role}` }
					);
				}
				break;
			case 'settings':
				if (data) {
					rp.host.open(
						`users-settings-role-${data.id_access_role}`,
						{ title: `${msg('Settings')}: ${data.role}` }
					);
				}
				break;
		}
	}

}
